import { AppType, APP_TYPE } from "../../app.type";
import { Inject, Injectable } from "@angular/core";
import { FilterDashboardServiceType } from "./filter-dashboard.service.type";
import { DashboardFilters } from "../../../../../shared/models/dashboard";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class FilterDashboardService implements FilterDashboardServiceType {
  isOpen = false;
  filters: DashboardFilters = new DashboardFilters();
  enableReset = false;
  createTimeFilters: { startDate: number; endDate: number } = {
    startDate: 0,
    endDate: 0,
  };
  selectedOptionFilters: { [fieldName: string]: string } = {};

  onFilterChange: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  constructor(@Inject(APP_TYPE) private app: AppType) {}

  getSelectedFilters() {
    this.filters = new DashboardFilters();

    if (this.createTimeFilters.startDate > 0) {
      this.filters.createTimeStart = this.createTimeFilters.startDate;
    }
    if (this.createTimeFilters.endDate > 0) {
      this.filters.createTimeEnd = this.createTimeFilters.endDate;
    }
    Object.keys(this.selectedOptionFilters).forEach((fieldName) => {
      const value = this.selectedOptionFilters[fieldName];

      if (value !== "") {
        this.filters[fieldName] = value;
      }
    });

    this.onFilterChange.next(true);
  }

  isFilterDisabled() {
    const hasCreateTimeFilter =
      this.createTimeFilters.startDate > 0 &&
      this.createTimeFilters.endDate > 0;
    const hasSelectedOptionFilter = Object.values(
      this.selectedOptionFilters
    ).some((value) => value !== "");

    return (
      !hasCreateTimeFilter &&
      !hasSelectedOptionFilter
    );
  }

  resetFilter(shouldTriggerApi: boolean) {
    this.createTimeFilters = {
      startDate: 0,
      endDate: 0,
    };
    this.selectedOptionFilters = {};
    this.filters = new DashboardFilters();
    this.onFilterChange.next(shouldTriggerApi);
    this.enableReset = false;
  }
}
